import React, { useEffect } from "react";
import clsx from "clsx";

import { useQuizContext } from "./QuizCollection";
import { usePLPContext } from "../ProductListingPage/ProductListingPage";

export const Results = () => {
    const { quizFunctions } = useQuizContext();
    const { quiz } = usePLPContext();

    return (
        <div className="quiz-results-wrapper container">
            {/* <div className="info-wrapper">
                <div className="info">
                    <div className="title">Quiz Results</div>
                    <div className="indicator-wrapper">
                        <div className="indicator-bars-wrapper">
                            {quizFunctions.currentAnswers.map((item, i) => ( 
                                <div  key={i} className={clsx('indicator-bar', 'currentStep')}></div>
                            ))}
                        </div>
                    </div>
                </div>
                
                <div className="filters-wrapper">
                    {quizFunctions.currentAnswers.map(obj => {
                        return (
                            <div className="filter">
                                {console.log(quizFunctions.currentAnswers)}
                                <div><b>{obj.question}:</b></div>
                                <div>{obj.answers.join(', ')}</div>
                            </div>
                        )
                    })}
                </div>
            </div> */}

            <div className="redo">
                <b style={{marginRight: '8px'}}>Something not right?</b>
                <button
                    className="start-over"
                    onClick={quizFunctions.handleQuizReset}
                >
                    Start Over
                </button>
            </div>

            <h1>{quizFunctions.title}</h1>

                        
        </div>
    );
};

// OLD DATA
/*
[
    {
      "question": "What activities are you interested in?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Activity",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Lifting",
          "value": "Lifting"
        },
        {
          "answer": "Yoga",
          "value": "Yoga"
        },
        {
          "answer": "Hiit",
          "value": "Hiit"
        },
        {
          "answer": "Everyday",
          "value": "Everyday"
        },
        {
          "answer": "Running",
          "value": "Running"
        }
      ]
    },
    {
      "question": "Are you looking for shorts or leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Clothing Type",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Shorts",
          "value": "Shorts"
        },
        {
          "answer": "Leggings",
          "value": "Leggings"
        },
        {
          "answer": "Both",
          "value": "Both"
        }
      ]
    },
    {
      "question": "What’s your preferred length for shorts?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Short Length",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Bike Shorts",
          "value": "Bike Shorts"
        },
        {
          "answer": "Referee Shorts",
          "value": "Referee Shorts"
        },
        {
          "answer": "Midway",
          "value": "Midway"
        },
        {
          "answer": "Booty Shorts",
          "value": "Booty Shorts"
        }
      ]
    },
    {
      "question": "What’s your preferred length for leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Legging Length",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "7/8 Length",
          "value": "7/8 Length"
        },
        {
          "answer": "Ankle Length",
          "value": "Ankle Length"
        },
        {
          "answer": "Full Length",
          "value": "Full Length"
        }
      ]
    },
    {
      "question": "What’s your preferred length for both shorts and leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Both Length",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "7/8 Length",
          "value": "7/8 Length"
        },
        {
          "answer": "Ankle Length",
          "value": "Ankle Length"
        },
        {
          "answer": "Full Length",
          "value": "Full Length"
        },
        {
          "answer": "Bike Shorts",
          "value": "Bike Shorts"
        },
        {
          "answer": "Referee Shorts",
          "value": "Referee Shorts"
        },
        {
          "answer": "Midway",
          "value": "Midway"
        },
        {
          "answer": "Booty Shorts",
          "value": "Booty Shorts"
        }
      ]
    },
    {
      "question": "What is your waistband height preference?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Waistband Height",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Mid Rise",
          "value": "Mid Rise"
        },
        {
          "answer": "High Rise",
          "value": "High Rise"
        },
        {
          "answer": "Super High Rise",
          "value": "Super High Rise"
        },
        {
          "answer": "Low Rise",
          "value": "Low Rise"
        },
        {
          "answer": "Show Me All",
          "value": "Show Me All"
        }
      ]
    },
    {
      "question": "What is your ideal level of compression?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Compression",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Mild",
          "value": "Mild"
        },
        {
          "answer": "Moderate",
          "value": "Moderate"
        },
        {
          "answer": "Firm",
          "value": "Firm"
        }
      ]
    },
    {
      "question": "What are your favourite features?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Features",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Pockets",
          "value": "Pockets"
        },
        {
          "answer": "Scrunch",
          "value": "Scrunch"
        },
        {
          "answer": "Non Scrunch",
          "value": "Non Scrunch"
        },
        {
          "answer": "Front Seam",
          "value": "Front Seam"
        },
        {
          "answer": "Supportive Waistband",
          "value": "Supportive Waistband"
        }
      ]
    },
    {
      "question": "Do you have a colour preference?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Testing-image-3.png?v=1695948291",
      "filter": "Colour",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Black",
          "value": "black"
        },
        {
          "answer": "Tonal Colours",
          "value": "tonal"
        },
        {
          "answer": "Coloured",
          "value": "coloured"
        },
        {
          "answer": "Patterns",
          "value": "patterns"
        }
      ]
    },
    {
      "question": "What is your preferred size?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Size",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "XXS",
          "value": "XXS"
        },
        {
          "answer": "XS",
          "value": "XS"
        },
        {
          "answer": "S",
          "value": "S"
        },
        {
          "answer": "M",
          "value": "M"
        },
        {
          "answer": "L",
          "value": "L"
        },
        {
          "answer": "XL",
          "value": "XL"
        },
        {
          "answer": "XXL",
          "value": "XXL"
        },
        {
          "answer": "XXXL",
          "value": "XXXL"
        },
        {
          "answer": "XXXXL",
          "value": "XXXXL"
        }
      ]
    }
  ]
*/

// NEW DATA
/*
[
    {
      "question": "What activities are you interested in?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Activity",
      "facet": "facets.Activity",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Lifting",
          "value": "Lifting"
        },
        {
          "answer": "Yoga",
          "value": "Yoga"
        },
        {
          "answer": "Hiit",
          "value": "Hiit"
        },
        {
          "answer": "Everyday",
          "value": "Everyday"
        },
        {
          "answer": "Running",
          "value": "Running"
        }
      ]
    },
    {
      "question": "Are you looking for shorts or leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Clothing Type",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Shorts",
          "value": "Shorts"
        },
        {
          "answer": "Leggings",
          "value": "Leggings"
        },
        {
          "answer": "Both",
          "value": "Both"
        }
      ]
    },
    {
      "question": "What’s your preferred length for shorts?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Short Length",
      "facet": "facets.Length",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Bike Shorts",
          "value": "Bike Shorts"
        },
        {
          "answer": "Referee Shorts",
          "value": "Referee Shorts"
        },
        {
          "answer": "Midway",
          "value": "Midway"
        },
        {
          "answer": "Booty Shorts",
          "value": "Booty Shorts"
        }
      ]
    },
    {
      "question": "What’s your preferred length for leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Legging Length",
      "facet": "facets.Length",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "7/8 Length",
          "value": "7/8 Length"
        },
        {
          "answer": "Ankle Length",
          "value": "Ankle Length"
        },
        {
          "answer": "Full Length",
          "value": "Full Length"
        }
      ]
    },
    {
      "question": "What’s your preferred length for both shorts and leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Both Length",
      "facet": "facets.Length",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "7/8 Length",
          "value": "7/8 Length"
        },
        {
          "answer": "Ankle Length",
          "value": "Ankle Length"
        },
        {
          "answer": "Full Length",
          "value": "Full Length"
        },
        {
          "answer": "Bike Shorts",
          "value": "Bike Shorts"
        },
        {
          "answer": "Referee Shorts",
          "value": "Referee Shorts"
        },
        {
          "answer": "Midway",
          "value": "Midway"
        },
        {
          "answer": "Booty Shorts",
          "value": "Booty Shorts"
        }
      ]
    },
    {
      "question": "What is your waistband height preference?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Waistband Height",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Mid Rise",
          "value": "Mid Rise"
        },
        {
          "answer": "High Rise",
          "value": "High Rise"
        },
        {
          "answer": "Super High Rise",
          "value": "Super High Rise"
        },
        {
          "answer": "Low Rise",
          "value": "Low Rise"
        },
        {
          "answer": "Show Me All",
          "value": "Show Me All"
        }
      ]
    },
    {
      "question": "What is your ideal level of compression?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Compression",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Mild",
          "value": "Mild"
        },
        {
          "answer": "Moderate",
          "value": "Moderate"
        },
        {
          "answer": "Firm",
          "value": "Firm"
        }
      ]
    },
    {
      "question": "What are your favourite features?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Features",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Pockets",
          "value": "Pockets"
        },
        {
          "answer": "Scrunch",
          "value": "Scrunch"
        },
        {
          "answer": "Non Scrunch",
          "value": "Non Scrunch"
        },
        {
          "answer": "Front Seam",
          "value": "Front Seam"
        },
        {
          "answer": "Supportive Waistband",
          "value": "Supportive Waistband"
        }
      ]
    },
    {
      "question": "Do you have a colour preference?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Testing-image-3.png?v=1695948291",
      "filter": "Colour",
      "facet": "facets.Colour",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Black",
          "value": "Black"
        },
        {
          "answer": "Tonal Colours",
          "value": "tonal"
        },
        {
          "answer": "Coloured",
          "value": "coloured"
        },
        {
          "answer": "Patterns",
          "value": "patterns"
        }
      ]
    },
    {
      "question": "What is your preferred size?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Size",
      "facet": "optionAvailability.Size",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "XXS",
          "value": "XXS"
        },
        {
          "answer": "XS",
          "value": "XS"
        },
        {
          "answer": "S",
          "value": "S"
        },
        {
          "answer": "M",
          "value": "M"
        },
        {
          "answer": "L",
          "value": "L"
        },
        {
          "answer": "XL",
          "value": "XL"
        },
        {
          "answer": "XXL",
          "value": "XXL"
        },
        {
          "answer": "XXXL",
          "value": "XXXL"
        },
        {
          "answer": "XXXXL",
          "value": "XXXXL"
        }
      ]
    }
]
*/
/* Updated
  [
    {
      "question": "What activities are you interested in?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Activity",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Lifting",
          "value": "Lifting"
        },
        {
          "answer": "Yoga",
          "value": "Yoga"
        },
        {
          "answer": "Hiit",
          "value": "Hiit"
        },
        {
          "answer": "Everyday",
          "value": "Everyday"
        },
        {
          "answer": "Running",
          "value": "Running"
        }
      ]
    },
    {
      "question": "Are you looking for shorts or leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Product Type",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Shorts",
          "value": "Shorts"
        },
        {
          "answer": "Leggings",
          "value": "Leggings"
        },
        {
          "answer": "Both",
          "value": "Both"
        }
      ]
    },
    {
      "question": "What’s your preferred length for both shorts and leggings?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Both Length",
      "facet": "facets.Length",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "7/8 Length",
          "value": "7/8 Length"
        },
        {
          "answer": "Ankle Length",
          "value": "Ankle Length"
        },
        {
          "answer": "Full Length",
          "value": "Full Length"
        }
      ]
    },
    {
      "question": "What is your waistband height preference?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Waistband Height",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Mid Rise",
          "value": "Mid Rise"
        },
        {
          "answer": "High Rise",
          "value": "High Rise"
        },
        {
          "answer": "Super High Rise",
          "value": "Super High Rise"
        },
        {
          "answer": "Low Rise",
          "value": "Low Rise"
        },
        {
          "answer": "Show Me All",
          "value": "Show Me All"
        }
      ]
    },
    {
      "question": "What is your ideal level of compression?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Compression",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "Mild",
          "value": "Mild"
        },
        {
          "answer": "Moderate",
          "value": "Moderate"
        },
        {
          "answer": "Firm",
          "value": "Firm"
        }
      ]
    },
    {
      "question": "What are your favourite features?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Features",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Pockets",
          "value": "Pockets"
        },
        {
          "answer": "Scrunch",
          "value": "Scrunch"
        },
        {
          "answer": "Non Scrunch",
          "value": "Non Scrunch"
        },
        {
          "answer": "Front Seam",
          "value": "Front Seam"
        },
        {
          "answer": "Supportive Waistband",
          "value": "Supportive Waistband"
        }
      ]
    },
    {
      "question": "Do you have a colour preference?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Testing-image-3.png?v=1695948291",
      "filter": "Colour",
      "facet": "facets.Colour",
      "multiple_choice": true,
      "answers": [
        {
          "answer": "Black",
          "value": "Black"
        },
        {
          "answer": "White",
          "value": "White"
        },
        {
          "answer": "Blue",
          "value": "Blue"
        },
        {
          "answer": "Print",
          "value": "Print"
        }
      ]
    },
    {
      "question": "What is your preferred size?",
      "image": "https://cdn.shopify.com/s/files/1/0017/6075/5779/files/Test_Image.png?v=1695945246",
      "filter": "Size",
      "facet": "optionAvailability.Size",
      "multiple_choice": false,
      "answers": [
        {
          "answer": "XXS",
          "value": "XXS"
        },
        {
          "answer": "XS",
          "value": "XS"
        },
        {
          "answer": "S",
          "value": "S"
        },
        {
          "answer": "M",
          "value": "M"
        },
        {
          "answer": "L",
          "value": "L"
        },
        {
          "answer": "XL",
          "value": "XL"
        },
        {
          "answer": "XXL",
          "value": "XXL"
        },
        {
          "answer": "XXXL",
          "value": "XXXL"
        },
        {
          "answer": "XXXXL",
          "value": "XXXXL"
        }
      ]
    }
]
*/